import { AppRouteProps } from "@mzara/component";
import ViewerContainer from "./container/ViewerContainer";

export const ViewerRoutes: Array<AppRouteProps> = [
    {
        path: "viewer/:id",
        element: <ViewerContainer />,
    },
];
